import { Component, AfterViewInit, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-paginator',
  standalone: false,
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() totalPages: number = 1;
  @Input() currentPage: number = 1;

  @Output() pageChange = new EventEmitter<number>();

  dataSelect: any[] = [];

  constructor(private el: ElementRef) {}
  
  get isPrevDisabled(): boolean {
    return this.currentPage <= 1;
  }

  get isNextDisabled(): boolean {
    return this.currentPage >= this.totalPages;
  }

  ngOnInit() {
    this.updateSelectData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['totalPages']) {
      this.updateSelectData();
    }
    if (changes['currentPage']) {
      this.updateSelectData();
    }
  }

  onSelect(event: any) {
    const selectedLabel = event.detail.option.label;
    const selected = Number(selectedLabel);
    this.setCurrentPage(selected);
  }

  onPrev() {
    if (!this.isPrevDisabled) {
      this.setCurrentPage(this.currentPage - 1);
    }
  }

  onNext() {
    if (!this.isNextDisabled) {
      this.setCurrentPage(this.currentPage + 1);
    }
  }

  private setCurrentPage(page: number) {
    this.currentPage = page;
    this.updateSelectData();
    this.pageChange.emit(page);
  }

  private updateSelectData() {
    this.dataSelect = Array.from({ length: this.totalPages }, (_, i) => ({
      label: `${i + 1}`,
      selected: i + 1 === this.currentPage,
      checked: false
    }));
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.installSelectWidthOverride();
      this.installEdgeCaretFix();
    });
  }

  private installSelectWidthOverride() {
    const host = this.el.nativeElement.querySelector('ds-select-box') as any;
    host?.shadowRoot?.append(
      Object.assign(document.createElement('style'), {
        textContent: `
          .ds-select-box__select {
            width: 6.1rem !important;
          }
        `
      })
    );
  }

  private installEdgeCaretFix() {
  const isEdge = /Edg\//.test(navigator.userAgent);
  if (!isEdge) return;

  const host = this.el.nativeElement.querySelector('ds-select-box') as any;
  const selectList = host?.shadowRoot?.querySelector('ds-select-list') as any;
  const dsInput = selectList?.shadowRoot?.querySelector('ds-input') as any;
  const input = dsInput?.shadowRoot?.querySelector('input') as HTMLInputElement | null;

  if (!input) return;

  
  input.readOnly = true;
  input.style.caretColor = 'transparent ';

} 

}
